import { FunctionComponent, Suspense, useMemo } from 'react'
import iconMap from '@/components/RebrandedHeroIcons/icon-map'
import { useStyles } from './styles'
import { IllustrationProps } from './types'
import { useRebrandingThemeGeneratorContext } from '@/rebrandedTheme/contexts/ThemeGeneratorContext'
import { RenderIf } from '../RenderIf'

export const Illustration: FunctionComponent<IllustrationProps> = ({
  name,
  color,
  width,
  height,
  size,
  hide,
  css,
  ...rest
}) => {
  const getWidth = useMemo(() => size || width || 'unset', [width, size])
  const getHeight = useMemo(() => size || height || 'unset', [height, size])
  const {
    theme: { controls },
  } = useRebrandingThemeGeneratorContext()

  const hideIllustration = useMemo(() => {
    if (hide === undefined) return controls?.flagDesabilitarIlustracoes
    else return hide
  }, [hide, controls?.flagDesabilitarIlustracoes])

  const styles = useStyles({
    color,
    width: getWidth,
    height: getHeight,
  })

  const IllustrationFragment = iconMap?.illustrations?.[name] || 'span'

  return (
    <RenderIf condition={!hideIllustration}>
      <Suspense fallback={<span />}>
        <IllustrationFragment
          css={[styles.illustrationWrapper, css]}
          {...rest}
        />
      </Suspense>
    </RenderIf>
  )
}
